import { CSSProperties } from 'react'
import { Typography, styled, Stack } from '@mui/material'
import { formatClock } from '$func/date'
import { t } from '$i18n'
import { PinMessage } from '$common/icons'
import { MESSAGE_VIEW_COUNT_IS_ENABLED } from '$config/env'
import { Views } from './views'
import { SendStatus } from './send-status'

const Root = styled('div')`
  display: flex;
  height: 14px;
  flex-direction: row-reverse;
  align-items: center;
  position: absolute;
  /* @noflip */
  left: 10px;
  bottom: 8px;
`

const TimeTypography = styled(Typography)`
  line-height: 12px;
  flex-shrink: 0;
  padding-top: 2px;
  /* @noflip */
  margin-right: 8px;
`

const StyledPinIcon = () => (
  <PinMessage
    sxProps={{
      color: 'gray',
      width: '14px',
      height: '14px',
      marginRight: '4px',
    }}
  />
)

const IconContainer = styled(Stack)`
  display: contents;
  /* @noflip */
  margin-right: 4px;
`

interface Props {
  iid: number
  time?: Date
  edited?: boolean
  canShowStatus: boolean
  overrideStyle?: CSSProperties
  viewCount: number
  pinned: boolean
}

export function TimeAndStatus({
  iid,
  time,
  edited,
  canShowStatus,
  overrideStyle,
  viewCount,
  pinned,
}: Props) {
  return (
    <Root style={overrideStyle}>
      <IconContainer>
        {canShowStatus && <SendStatus iid={iid} />}
        {time && (
          <TimeTypography variant="caption1" color="neutral500">
            {formatClock(time)}
          </TimeTypography>
        )}
        {MESSAGE_VIEW_COUNT_IS_ENABLED && <Views views={viewCount} />}
        {pinned && <StyledPinIcon />}
      </IconContainer>

      {edited && (
        <Typography
          sx={{
            marginRight: '8px',
          }}
          flexShrink={0}
          variant="caption2"
          color="neutral500"
        >
          {t('message.edited')}
        </Typography>
      )}
    </Root>
  )
}

TimeAndStatus.defaultProps = {
  time: null,
  edited: false,
  overrideStyle: null,
}
